import type { AdConfig } from '../../types/metaAdDraft';

// Feature A — pure decision for seeding a NEW draft's conversion pixel + lead
// form from the account-level defaults on account-pick. Mirrors igDefaultPatch:
// fills ONLY empty selectors — never clobbers a value the AM already set (a
// reopened/edited draft, or one already changed this session).
//
//   - pixel: fills `ads.pixelId` when empty (applies regardless of objective).
//   - lead form: fills the instant-form destination's `leadGenFormId` when the
//     destination IS an instant form and the form is empty. The display name is
//     left as-is — AdSection resolves it from the live lead-form list by id.
//
// Returns the `ads` patch to merge, or null when there's nothing to apply
// (defaults absent, or selectors already populated).

type AdsSlice = Pick<AdConfig, 'pixelId' | 'destination'>;

export function accountDefaultsPatch(
  ads: AdsSlice,
  account: { defaultPixelId: string | null; defaultLeadFormId: string | null },
): Partial<AdsSlice> | null {
  const patch: Partial<AdsSlice> = {};

  const pixelEmpty = !(typeof ads.pixelId === 'string' && ads.pixelId.trim() !== '');
  if (pixelEmpty && account.defaultPixelId) patch.pixelId = account.defaultPixelId;

  if (ads.destination.type === 'instant_form') {
    const formEmpty = ads.destination.leadGenFormId.trim() === '';
    if (formEmpty && account.defaultLeadFormId) {
      patch.destination = {
        type: 'instant_form',
        leadGenFormId: account.defaultLeadFormId,
        // Name resolves from the live list (AdSection); keep any existing label.
        leadGenFormName: ads.destination.leadGenFormName,
      };
    }
  }

  return Object.keys(patch).length > 0 ? patch : null;
}
